import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { animateScroll } from "react-scroll";
import { IoLogoTwitter, IoLogoVimeo, IoLogoPinterest } from "react-icons/io";
import { MdExpandLess } from "react-icons/md";
import { FaHeart, FaPhoneAlt} from "react-icons/fa";
import styles from "./Footer.module.scss";
import logo from "../../../assets/images/logo/logo.png";
import logoDark from "../../../assets/images/logo/v2.png";

const Footer = ({ footerBg }) => {
  const [scroll, setScroll] = useState(0);
  const [top, setTop] = useState(0);

  useEffect(() => {
    setTop(100);
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const scrollToTop = () => {
    animateScroll.scrollToTop();
  };

  const handleScroll = () => {
    setScroll(window.scrollY);
  };
  return (
    <>
    <footer
      className={`footer-area ${footerBg === "white" ? styles.footer2 : ""}`}
    >
      <div
        className={`${styles.footerTop} ${footerBg === "white" ? "bg--cart-7" : "bg--cart-2"
          }`}
      >
        <div className="container">
          <div className="row">
            {/* Start Single Wedget */}
            <div className="col-12 col-sm-6 col-lg-3">
              <div className={styles.singleWidget}>
                <div className={styles.logo}>
                  <Link to={process.env.PUBLIC_URL + "/"}>
                    <img
                      src={footerBg === "white" ? logoDark : logo}
                      alt="voip"
                      className="footer-logo"
                    />
                  </Link>
                </div>
                <div className={styles.content}>
                  <p>
                    Adaptive System LLC Partner with Perfect Vision is a next-generation digital service provider offering high-speed internet, cable TV, and mobile connectivity across the U.S. Our mission is to deliver fast, reliable, and affordable connectivity to homes and businesses—no matter where you are.
                  </p>
                </div>
              </div>
            </div>
            {/* End Single Wedget */}
            {/* Start Single Wedget */}
            <div className="col-12 col-sm-6 col-lg-2 offset-lg-1 xs__mt--40">
              <div className={styles.singleWidget}>
                <h2 className={styles.ftTitle}>Links</h2>
                <ul className={styles.ftContactLink}>
                  <li>
                    <Link to={process.env.PUBLIC_URL + "/"}>
                      Home
                    </Link>
                  </li>
                  <li>
                    <a href={process.env.PUBLIC_URL + "/#plans"}>
                      Plans
                    </a>
                  </li>
                  <li>
                    <Link to={process.env.PUBLIC_URL + "/about"}>
                      About
                    </Link>
                  </li>
                  <li>
                    <Link to={process.env.PUBLIC_URL + "/contact"}>Contact</Link>
                  </li>
                </ul>
              </div>
            </div>
            {/* End Single Wedget */}
            {/* Start Single Wedget */}
            <div className="col-lg-2 offset-lg-1 col-md-6 col-sm-6 col-12 sm__mt--40 md__mt--40">
              <div className={styles.singleWidget}>
                <h2 className={styles.ftTitle}>Policies</h2>
                <ul className={styles.ftContactLink}>
                  <li>
                    <Link to={process.env.PUBLIC_URL + "/disclaimer"}>Disclaimer</Link>
                  </li>
                  <li>
                    <Link to={process.env.PUBLIC_URL + "/privacy-policy"}>
                      Privacy Policy
                    </Link>
                  </li>
                  <li>
                    <Link to={process.env.PUBLIC_URL + "/refund-policy"}>
                      Refund Policy
                    </Link>
                  </li>
                  <li>
                    <Link to={process.env.PUBLIC_URL + "/terms-of-service"}>Terms of Service</Link>
                  </li>
                  <li>
                    <Link to={process.env.PUBLIC_URL + "/do-not-sell-my-info"}>Do Not Sell My Info</Link>
                  </li>
                  <li>
                    <Link to={process.env.PUBLIC_URL + "/tcpa-consent"}>TCPA Consent</Link>
                  </li>
                </ul>
              </div>
            </div>
            {/* End Single Wedget */}
            {/* Start Single Wedget */}
            <div className="col-lg-2 offset-lg-1 col-md-6 col-sm-6 col-12 sm__mt--40 md__mt--40">
              <div className={styles.singleWidget}>
                <h2 className={styles.ftTitle}>Contact Us</h2>
                <ul className={styles.ftContactLink}>
                  <li>
                    <a href="tel:+1 (877) 514-5141">
                      (877) 514-5141
                    </a>
                  </li>
                  <li>
                    <Link to={process.env.PUBLIC_URL + "#"}>
                      info@adaptivesystems-llc.com
                    </Link>
                  </li>
                  <li>
                    <Link>2420 Kates Pl ,Prosper, TX 75078</Link>
                  </li>
                  <li>
                    <Link to={process.env.PUBLIC_URL + "#/"}>9:00 - 5:00</Link>
                  </li>

                </ul>
              </div>
            </div>
            {/* End Single Wedget */}
          </div>
        </div>
      </div>
      <div
        className={`${styles.copyright}  ${footerBg === "white" ? "bg--cart-8" : "bg--cart-3"
          }`}
      >
        <div className="container">
          <div className="row align-items-center">
            <div className="col-12 col-sm-6">
              <div className={styles.copyrightInner}>
                <p className="copyright-text">
                  Copyright © 2025 | Powered by Adaptive Systems LLC
                </p>
              </div>
            </div>
            <div className="col-12 col-sm-6">
            </div>
          </div>
        </div>
      </div>
      <button
        className={`scroll-top ${scroll > top ? "show" : ""}`}
        onClick={() => scrollToTop()}
      >
        <MdExpandLess />
      </button>
    </footer>
    <section className="sticky">
    <div className="container">
      <FaPhoneAlt className="icon"/> <a href="tel:+1(877) 514-5141">+1(877) 514-5141</a>
    </div>
  </section>
  </>
  );
};

Footer.propTypes = {
  footerBg: PropTypes.string
};

export default Footer;
